import React from "react";
import { paginationLimitOptionArr } from "../../utilities/const";
import { Form } from "react-bootstrap";

const PaginationFilter = ({ setBody, body }) => {
  return (
    <li className="d-flex align-items-center gap-10">
      <label htmlFor="" className="form-label m-0 text-muted">
        Showing
      </label>
      <Form.Select
        aria-label="Default select example"
        className=" form-control"
        defaultValue={body.limit}
        onChange={(e) =>
          setBody((p) => ({
            ...p,
            limit: +e.target.value,
          }))
        }
      >
        {paginationLimitOptionArr?.map((item) => (
          <option value={item}>{item}</option>
        ))}
      </Form.Select>
    </li>
  );
};

export default PaginationFilter;
